<div class="max-md:bg-gradient-to-r min-w-[260px] md:min-w-[320px] sm:min-h-[361px] max-md:bg-[linear-gradient(266deg,#FFF_1.02%,#F1EBFF_101.59%)] md:bg-white rounded-[10px] pt-1.5 md:pt-4 relative overflow-hidden border border-white shadow-[0_1px_6px_0_#10182814,0_-1px_6px_0_#10182814] flex flex-col"
    *transloco="let t; currentLang as currentLang">
    <img src="images/dot-vector.svg" class="absolute top-0 right-0 w-auto max-md:h-[120px] pointer-events-none" />

    @if (isLoading()) {
    <!-- Mobile Bottom Sheet Loader / Desktop In-Card Loader -->
    <div class="fixed inset-0 bg-black/40 z-40 md:hidden" (click)="cancelLoading()">
    </div>
    <div @dropdownAnimation class="p-3 bg-[linear-gradient(180deg,#FFF_0%,#F1EBFF_211.79%)] fixed inset-x-0 bottom-0 z-50 max-h-[90vh] overflow-y-auto
                rounded-t-2xl shadow-[0_-4px_16px_rgba(16,24,40,0.12)]
                md:static md:z-auto md:max-h-none md:overflow-visible
                md:rounded-none md:shadow-none md:p-0 md:bg-transparent">
        <div class="flex justify-center mb-2 md:hidden">
            <span class="w-10 h-1 rounded-full bg-[#D0D5DD]"></span>
        </div>
        <app-ai-matching-loader [isApiComplete]="isApiDataReady()"
            (completed)="onLoaderComplete()"></app-ai-matching-loader>
    </div>
    } @else {
    <div class="flex flex-row max-md:justify-between md:flex-col relative z-10 px-2.5 md:px-4 ">
        <div>
            <div class="mb-2">
                <span class="text-[#344054] font-semibold text-xs md:text-lg">
                    {{ t('matchingPercentageTitle') }}
                </span>
                <img [src]="environment.homeImageUrl + 'pro-badge.svg'" class="inline-block md:w-fit md:h-fit h-2.5" />
            </div>
            <div class="block md:hidden relative w-fit overflow-hidden rounded-full p-[1px] md:w-fit mb-3">
                <div
                    class="pointer-events-none absolute left-1/2 top-1/2 aspect-square w-[160%]
                                         -translate-x-1/2 -translate-y-1/2
                                         animate-[spin_2.5s_linear_infinite]
                                         bg-[conic-gradient(from_0deg,#E8F0F5_0deg,#E8F0F5_250deg,#BD99FF_270deg,#66A6FF_305deg,#9B63FF_340deg,#E8F0F5_360deg)]">
                </div>

                <button (click)="MatchingScoreBreakdown()" class="mr-1 relative flex w-full cursor-pointer items-center justify-center gap-1
                                       rounded-full bg-white hover:bg-[#F9FAFB] px-3 py-1
                                       shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]
                                       md:w-fit md:py-2.5">
                    <span
                        class="bg-[linear-gradient(180deg,#0D5DFD_0%,#5723D2_100%)] bg-clip-text text-[9px] font-semibold text-transparent md:text-xs">
                        {{ t('seeDetails') }}
                    </span>

                    <img src="images/arrow-right-violet.svg" alt="" class="h-[9px] w-[9px] md:h-auto md:w-auto" />
                </button>
            </div>
        </div>

        <p class="text-[#101828] font-normal text-xs md:block hidden">{{ t('matchingPercentageDescription') }}
        </p>

        @if(isBrowser){
        <div class="flex flex-col items-center justify-center max-md:-mt-2 ">
            <app-match-gauge [percent]="matchingPercentage()"
                [isDisabled]="hasMandatoryUnmatched() || matchingPercentage() ===-100"
                [isMatchingDataReady]="effectiveIsMatchingApiCalled()" [currentLang]="currentLang"
                [label]="t('Matched')" [fallbackLabel]="t('readyToMatch')">
            </app-match-gauge>
        </div>
        }
    </div>

    @if(showDetails() && effectiveIsMatchingApiCalled()){
    <div class="fixed inset-0 bg-black/40 z-40 md:hidden" (click)="showDetails.set(false)">
    </div>
    <div @dropdownAnimation class="p-4 bg-[linear-gradient(180deg,#FFF_0%,#F1EBFF_211.79%)] fixed inset-x-0 bottom-0 z-50 max-h-[85vh] overflow-y-auto
                rounded-t-2xl shadow-[0_-4px_16px_rgba(16,24,40,0.12)]
                md:static md:z-auto md:max-h-none md:overflow-visible
                md:rounded-none md:shadow-none">
        @if(aiMatchInfo().length > 0){
        <div
            class="rotating-border relative border border-[#E4E7EC] shadow-[0_1px_4px_0_rgba(152,94,255,0.14)] rounded-xl mb-4">

            <div class="rounded-[14px] bg-[linear-gradient(180deg,#FFFFFF_0%,#FBFAFF_38%,#F5F3FF_100%)] p-3.5 pt-1.5">

                <div class="flex items-center justify-between">
                    <div class="-ml-1.5">
                        <img src="images/star-element.svg" class="rotate-180" />
                    </div>

                    <p>
                        <span class="mr-2 inline-block text-base font-semibold text-[#8C4DFF] mt-1">
                            AI Match Assessment
                        </span>
                        <img src="images/help.svg" class="inline-block h-4 w-4" />
                    </p>

                    <div class="-mr-1.5">
                        <img src="images/star-element.svg" />
                    </div>
                </div>

                @for (item of aiMatchInfo(); track $index) {
                <div class="mt-4">
                    <div class="mb-2.5 flex items-center justify-between">
                        <p class="text-sm font-medium text-[#101828]">{{item.criteriaName}}</p>

                        <p
                            class="w-fit rounded-full border-[1.5px] border-white/40 bg-white/30 px-2 py-0.5 shadow-[0_1px_2px_0_rgba(16,24,40,0.06)] backdrop-blur-md">
                            <span class="text-[11px] font-medium text-[#DC6803]">
                                {{item.status}}
                            </span>
                        </p>
                    </div>

                    <p class="text-xs font-normal leading-[18px] text-[#344054]">
                        {{item.statusReason}}
                    </p>

                    @if (!$last) {
                    <svg class="my-3" [class.scale-x-[-100%]]="$odd" xmlns="http://www.w3.org/2000/svg" width="261"
                        height="1" viewBox="0 0 261 1" fill="none">
                        <path d="M260.5 0.5L0.500007 0.499977" stroke="url(#paint0_linear_63955_54740)"
                            stroke-linecap="round" />
                        <defs>
                            <linearGradient id="paint0_linear_63955_54740" x1="260.5" y1="-0.5" x2="260.484"
                                y2="2.09385" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#CE9EFF" stop-opacity="0.05" />
                                <stop offset="0.360346" stop-color="#CE9EFF" />
                                <stop offset="0.556621" stop-color="#CE9EFF" />
                                <stop offset="1" stop-color="white" stop-opacity="0.08" />
                            </linearGradient>
                        </defs>
                    </svg>
                    }
                </div>
                }

            </div>
        </div>
        }
        <div class="flex justify-center mb-2 md:hidden">
            <span class="w-10 h-1 rounded-full bg-[#D0D5DD]"></span>
        </div>
        <div class=" md:rounded-[14px] md:border md:border-[#E6E6E7] md:shadow-[0_1px_4px_0_rgba(152,94,255,0.14)]">
            @if(hasMandatoryUnmatched()){
            <div class="md:p-3.5">
                <p>{{t('unmatchedMandatory')}}</p>
            </div>
            }
            @else if(matchingPercentage() === -100){
            <div class="md:p-3.5">
                <p>{{t('notGeneratedYet')}}</p>
            </div>
            }
            @else {
            <div class="flex justify-between items-center md:px-3.5 py-3 border-b border-[#D0D5DD] mb-4">
                <p class="text-[#101828] font-semibold text-lg flex items-center gap-1">
                    {{ t('matchDetails') }}
                </p>
                <div class="flex items-center gap-1">
                    <img [src]="environment.homeImageUrl + 'speedometer.svg'" />
                    <span class="text-[#C63C92] font-bold text-xl"> {{ currentLang === 'bn' ? (matchingPercentage() |
                        toBanglaNumber) : matchingPercentage() }}% </span>
                </div>
            </div>
            <div class="pb-6 flex items-center justify-between md:px-3.5">
                <p class="text-[#B32D7D] font-medium text-xs">{{t('Requirement')}}</p>
                <p class="text-[#B32D7D] font-medium text-xs">{{t('summary')}}</p>
            </div>
            @for(item of matchingInfo(); track $index){
            <div [class.hidden]="item.status !== matchingStatus.notGenerateYet"
                class="px-3.5 pb-4 flex items-center justify-center w-full gap-2">
                <div class="flex-1 border-b border-[#D0D5DD]"></div>
                <p class="text-[#344054] text-[10px] font-medium whitespace-nowrap">
                    {{t('willBeCalculated')}}
                </p>
                <div class="flex-1 border-b border-[#D0D5DD]"></div>
            </div>
            <div class="flex items-center justify-between gap-2 mb-4 md:px-3.5">

                <div class="min-w-0 flex-1 mb-1">
                    <span class="whitespace-nowrap text-[#344054] text-sm font-medium">{{item.criteriaName |
                        transloco}}</span>
                </div>
                <span [style.backgroundColor]="item.bgColor" [style.borderColor]="item.borderColor"
                    [style.color]="item.textColor"
                    class="shrink-0 whitespace-nowrap text-[11px] font-medium text-[#079455] border border-[rgba(15,148,88,0.40)] px-2 py-1 rounded-full bg-[rgba(222,255,240,0.10)] shadow-[0_1px_2px_0_rgba(16,24,40,0.06)]">
                    {{item.status | transloco}}
                </span>
            </div>
            @if( item.status?.toLowerCase() === matchingStatus.partlyMatched.toLowerCase() &&
            item.criteriaName?.toLowerCase() === 'experience'){
            <p class="mt-[-8px] mb-4 flex w-full items-center gap-1 md:px-3.5">
                <span class="text-[10px] leading-4 text-[#DC6803]">{{item.statusReason | transloco}}</span>
            </p>
            }
            @if (!$last && matchingInfo()[$index + 1].status !== matchingStatus.notGenerateYet) {
            <div
                class="md:mx-3.5 my-4 h-px bg-[repeating-linear-gradient(to_right,#D0D5DD_0,#D0D5DD_8px,transparent_8px,transparent_14px)]">
            </div>
            }
            }
            }
        </div>
        <div (click)="showDetails.set(false)"
            class="max-md:hidden flex items-center justify-center gap-1 cursor-pointer text-center mt-4">
            <span class="text-[#C63C92] text-sm font-semibold">
                {{ t('seeLess') }}
            </span>
            <img src="images/chevron-pink.svg" class="w-4 h-4" />
        </div>
    </div>
    } @else {
    <div class="relative max-md:hidden overflow-hidden rounded-b-[10px]
            bg-[linear-gradient(180deg,rgba(252,250,255,0)_0%,rgba(241,242,253,0.65)_51.39%)]
            text-center flex flex-col items-center justify-center py-6 pb-5
            flex-1">

        <!-- Blurred rounded top line -->
        <div class="absolute top-0 left-1/2 -translate-x-1/2
                h-[2px] w-[90%]
                rounded-b-full
                bg-[#7F7F800F] from-transparent via-[#C4A6FF] to-transparent
                blur-[1.5px]">
        </div>

        <p class="opacity-10 max-md:hidden -translate-y-3">
            <span class="mr-2 inline-block text-lg font-semibold text-[#8C4DFF] mt-1 mb-2">
                {{ t('matchDetails') }}
            </span>
        </p>

        <div class="relative w-full overflow-hidden rounded-full p-[1px] md:w-fit">

            <div
                class="pointer-events-none absolute left-1/2 top-1/2 aspect-square w-[160%]
                    -translate-x-1/2 -translate-y-1/2
                    animate-[spin_2.5s_linear_infinite]
                    bg-[conic-gradient(from_0deg,#E8F0F5_0deg,#E8F0F5_250deg,#BD99FF_270deg,#66A6FF_305deg,#9B63FF_340deg,#E8F0F5_360deg)]">
            </div>

            <button (click)="MatchingScoreBreakdown()" class="relative flex w-full cursor-pointer items-center justify-center gap-1
                    rounded-full bg-white hover:bg-[#F9FAFB] px-9 py-1
                    shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]
                    md:w-fit md:py-2.5">

                <span class="bg-[linear-gradient(180deg,#0D5DFD_0%,#5723D2_100%)]
                        bg-clip-text text-[9px] font-semibold text-transparent md:text-xs">
                    {{ t('seeDetails') }}
                </span>

                <img src="images/arrow-right-violet.svg" alt="" class="h-[9px] w-[9px] md:h-auto md:w-auto" />
            </button>
        </div>
    </div>
    }
    }
</div>

@if(showPricingPop()){
<app-pro-modal [didnotSetOnLocalStorage]="true" (closePop)="showPricingPop.set(false)"></app-pro-modal>
}